module.exports = __webpack_public_path__ + "img/DP158.5b7a5d21.png";